import React from "react";

const AdmisionCursosSeleccionados = ({
  datosInscripcion = {},
  color = "bg-primarioMira",
}) => {
  return (
    <>
      <div
        className={`grid grid-cols-1 ${color} col-span-2 px-4 py-4 p-2 rounded-lg`}
      >
        {datosInscripcion.NombreCompletoAlumno !== undefined ? (
          <>
            <h2 className="col-span-full text-sm text-white">
              Nombre del alumno{" "}
            </h2>
            <h2 className="flex text-sm text-secundario ">
              {datosInscripcion.NombreCompletoAlumno}
            </h2>
          </>
        ) : null}

        {datosInscripcion.Carnet !== undefined ? (
          <>
            <h2 className="col-span-full text-sm text-white">Carnet </h2>
            <h2 className="flex text-sm text-secundario ">
              {datosInscripcion.Carnet}
            </h2>
          </>
        ) : null}

        {datosInscripcion.Solicitud !== undefined ? (
          <>
            <h2 className="col-span-full text-sm text-white">Solicitud </h2>
            <h2 className="flex text-sm text-secundario ">
              {datosInscripcion.Solicitud}
            </h2>
          </>
        ) : null}

        {datosInscripcion.Sede !== undefined ? (
          <>
            <h2 className="col-span-full text-sm text-white">Campus</h2>
            <h2 className="flex text-sm text-secundario ">
              {datosInscripcion.Sede}
            </h2>
          </>
        ) : null}

        {datosInscripcion.Plan !== undefined ? (
          <>
            <h2 className="col-span-full text-sm text-white ">Plan</h2>
            <h2 className="grid text-sm text-secundario ">
              {datosInscripcion.Plan}
            </h2>
          </>
        ) : null}

        {datosInscripcion.Carrera !== undefined ? (
          <>
            <h2 className="col-span-full text-sm text-white ">
              Nivel académico
            </h2>
            <h2 className="grid text-sm text-secundario ">
              {datosInscripcion.Carrera}
            </h2>
          </>
        ) : null}

        {datosInscripcion.Grado !== undefined ? (
          <>
            <h2 className="col-span-full text-sm text-white ">Grado a inscribir</h2>
            <h2 className="grid text-sm text-secundario">
              {datosInscripcion.Grado}
            </h2>
          </>
        ) : null}
      </div>
    </>
  );
};

export default AdmisionCursosSeleccionados;
